export default {
  namespaced: true,
  state: {
    currentStep: 1,
    userCategories: {},
    currentCategories: []
  },
  mutations: {
    setCurrentStep(state, currentStep) {
      state.currentStep = currentStep
    },
    resetUserCategories(state, categories) {
      categories.forEach((category) => {
        state.userCategories[category.id] = {
          outputKind: 'interest',
          outputTitle: '',
          outputValue: '',
          outputMeta: {}
        }
      })
    },
    setUserCategories(state, userCategories) {
      state.userCategories[userCategories.category.id] = {
        outputKind: 'interest',
        outputTitle: userCategories.subcategory.label,
        outputValue: `${userCategories.category.id}:${userCategories.subcategory.id}`,
        outputMeta: {}
      }
    },
    setCurrentCategories(state, currentCategories) {
      state.currentCategories = currentCategories
    }
  },
  actions: {
    async createUserOutputs({ state, dispatch }) {
      const categories = {
        outputs: []
      }
      for (const key in state.userCategories) {
        categories.outputs.push(state.userCategories[key])
      }
      const response = await dispatch('outputs/createManyOutputs', categories, { root: true })
      return response.data
    }
  },
  getters: {
    currentStep: (state) => state.currentStep,
    userCategories: (state) => state.userCategories,
    currentCategories: (state) => state.currentCategories
  }
}
